import { Navigate, createFileRoute } from '@tanstack/react-router';

import { PlacementEditorPage } from '../features/supply/placements/components/PlacementEditorPage';
import { PlacementType } from '../features/supply/placements/model';

export const Route = createFileRoute('/supply/placements_/create/$placementType')({
  component: CreatePlacementRoute,
});

function CreatePlacementRoute() {
  const { placementType } = Route.useParams();
  let type: PlacementType | null = null;
  if (placementType === 'standard') type = PlacementType.Standard;
  if (placementType === 'ad-unit') type = PlacementType.AdUnit;
  return type ? (
    <PlacementEditorPage placementType={type} />
  ) : (
    <Navigate to="/supply/placements" replace />
  );
}
